export default {
  whatSearch: '¿Qué estás buscando?',
  products: 'Productos',
  filtersBy: 'Filtrar por',
  delete: 'Cancelar',
  popularSearch: 'Búsquedas populares',
}
